import media from "./media";
import React, { useState } from "react";



function BookPage(props) {
  
    return (
        <>
          <div className="bookpage-container-container-orwhatever">

       <div className= {props.mediaIsSelected ?'bookpage-wrapper':'page-hidden'}> 
            <button className="x-close-bookpage" onClick={()=>props.setMediaSelected(false)}>{'<'}─ back to library</button> 
          
          <div className="bookpage-container">

        <  img className="bookpage-img" src = {props.selectedMedia.thumbnail}></img>
          <div id="library-description">

            <div id='desc-contents'>

                <div className="media-tags">
                    {props.selectedMedia.tags.map((tag, index) =>
                    <>

                        <p className="media-tag">{tag} </p>
                        {(index < props.selectedMedia.tags.length - 1) ? <p>⊹</p> : ""}
                    </>

                    )}

                </div>
                <p id="media-title">{props.selectedMedia.title}</p>
                <p id="media-author"> ☽ .* :☆ﾟ.   ──────   by<b>{props.selectedMedia.author}</b></p>
                <p id="media-translator" style={{ display: props.selectedMedia.translated ? 'block' : 'none' }}>translation by: {props.selectedMedia.translator}</p>
                
                {(Object.hasOwn(props.selectedMedia, 'quote')) ?
                <div className="media-quote">
                  <p>{props.selectedMedia.quote}</p>
                </div>
                :  ''}
                
                <div className="media-description">
                  {props.selectedMedia.long_desc.map((paragraph, index) =>
                  <>
                  <p>{paragraph}</p>
                  {(index < props.selectedMedia.long_desc.length - 1) ? <br/> : ""}
                  </>
                  )}
                </div>
                
                <div className="media-links-container">
                    <p>─── ⋅ ∙ ∘  Access at:   ∘ ⋅ ⋅ ───</p>
                    <div className="media-links">
                    {props.selectedMedia.links.map((link, index) =>
                    <div className="media-link">
                        <p>⋅⊱</p>
                        <a  target="_blank" rel="noopener noreferrer" href={link.source}>{link.title}</a>
                    </div>
                    
                    )}
                </div>
                </div>
                
              </div>
            </div>

          </div>
           {/* If object has a gallery, display it: */}
                {(Object.hasOwn(props.selectedMedia, 'gallery')) ?
                    <div className="gallery">
                        {props.selectedMedia.gallery.map(item =>
                            <div className="book-gallery-item">
                            {(item.type == 'img') ?
                                <img src={item.src}></img>

                            : ""}
                            {(item.type == 'video') ?
                                <video controls>
                                    <source src={item.src} type="video/mp4" />

                                    </video>

                            : ""}
                            </div>
                            )}
                    </div>
                
                :""}
          </div>
          </div>
    </>
          
    );
  }

  export default BookPage;